import { Injectable } from '@angular/core';
import { SummaryButton, SummaryItems, SummarySplitButton } from 'fc-ui-components';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MainNavigationSummaryBarService {
    private summaryBarConfig = new BehaviorSubject<SummaryBarConfig>(this.defaultConfig());

    getSummaryBarConfig() {
        return this.summaryBarConfig.asObservable();
    }

    setSummaryBar(config: SummaryBarConfig) {
        this.summaryBarConfig.next({
            ...this.defaultConfig(),
            ...config
        });
    }

    resetSummaryBar() {
        this.summaryBarConfig.next(this.defaultConfig());
    }

    private defaultConfig(): SummaryBarConfig {
        return {
            show: of(false),
            title: '',
            hideSummary: false,
            summary: of({ first: { title: '', value: '' } }),
            button: of({ enabled: false }),
            splitButton: of({ label: '', enabled: false, items: [] }),
            secondaryButton: of({ enabled: false }),
            secondSecondaryButton: of({ enabled: false })
        };
    }
}

export interface SummaryBarConfig {
    title?: string;
    hideSummary?: boolean;
    show: Observable<boolean>;
    summary?: Observable<SummaryItems>;
    button?: Observable<SummaryButton>;
    splitButton?: Observable<SummarySplitButton>;
    secondaryButton?: Observable<SummaryButton>;
    secondSecondaryButton?: Observable<SummaryButton>;
    onClick?: () => void;
    onSecondaryClick?: () => void;
    onSecondSecondaryClick?: () => void;
}
